import React from 'react';
import styled from 'styled-components';

import useSite from '../hooks/use-site';
import useCompany from '../hooks/use-company';

const Maps = ({
  className,
  name,
  street,
  houseNumber,
  city,
}) => {
  const { googleMapsApiKey } = useSite();

  const {
    name: companyName,
    street: companyStreet,
    houseNumber: companyHouseNumber,
    city: companyCity,
  } = useCompany();

  // when given `city`, we use the given values, else the company defaults
  const query = encodeURIComponent(city ? `${name ? `${name},` : ''}${street || ''} ${houseNumber || ''},${city || ''}` : `${companyName ? `${companyName},` : ''}${companyStreet || ''} ${companyHouseNumber || ''},${companyCity || ''}`);

  return (
    <iframe
      className={className}
      title="maps"
      frameBorder="0"
      src={`https://www.google.com/maps/embed/v1/place?q=${query}&key=${googleMapsApiKey}`}
      allowFullScreen
      referrerPolicy="origin"
    />
  );
};

export default styled(Maps)`
  display: block;
  width: 100%;
  height: 16rem;
`;
